import React from 'react';
import ReactMarkdown from 'react-markdown';
import './MarkdownContent.css';

function MarkdownContent({ content, className = '' }) {
  if (!content) return null;
  
  return (
    <div className={`markdown-content ${className}`}>
      <ReactMarkdown
        components={{
          // Open links in new tab
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer" />
          ),
          // Add proper styling for code blocks
          code: ({ node, inline, className, children, ...props }) => {
            return inline ? (
              <code className="inline-code" {...props}>
                {children}
              </code>
            ) : (
              <pre className="code-block">
                <code {...props}>{children}</code>
              </pre>
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}

export default MarkdownContent;
